import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Route,
  Redirect,
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import { Layout, Menu, Dropdown, Button } from "antd";
import cookie from "react-cookies";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const history = useHistory();

  useEffect(() => {}, []);

  return (
    <div className="cover">
      <div className="title">ADAPT</div>
      <div className="subtitle">{t("pages.cover.subtitle")}</div>
      <img
        className="img"
        src={require("../../../assets/image/login.png").default}
      />
    </div>
  );
};

export default Footer;
